<div class="card">
    <h5>Stacked</h5>
    <p-chart type="bar" [data]="stackedData" [options]="stackedOptions"></p-chart>
</div>